/**
 * Helper function to deeply compare two values for equality
 * Handles primitives, arrays, and objects
 */
function valuesAreEqual(value1, value2) {
	// Handle null/undefined cases
	if (value1 === value2) return true
	if (value1 == null || value2 == null) return false

	// Handle arrays
	if (Array.isArray(value1) && Array.isArray(value2)) {
		if (value1.length !== value2.length) return false
		for (let i = 0; i < value1.length; i++) {
			if (!valuesAreEqual(value1[i], value2[i])) return false
		}
		return true
	}

	// Handle objects
	if (typeof value1 === 'object' && typeof value2 === 'object') {
		const keys1 = Object.keys(value1)
		const keys2 = Object.keys(value2)
		if (keys1.length !== keys2.length) return false
		for (let key of keys1) {
			if (!keys2.includes(key) || !valuesAreEqual(value1[key], value2[key])) {
				return false
			}
		}
		return true
	}

	// Handle primitives
	return value1 === value2
}

export let attributeLabel = {
	computed: {
		isRequired: function () {
			let itemValidationRules = this.$store.getters.getItemValidationRules
			let itemData = this.$store.getters.getItemData || this.itemData
			let that = this
			let required = false

			for (let i = 0; i < itemValidationRules.length; i++) {
				let rule = itemValidationRules[i]

				// Check if rule has a condition
				if (rule.condition && rule.condition.attribute) {
					let conditionAttribute = rule.condition.attribute
					let conditionValue = rule.condition.value

					// Get actual value from itemData
					let actualValue = itemData ? itemData[conditionAttribute] : undefined

					// If condition value is set but doesn't match actual value, skip this rule
					if (conditionValue !== null && conditionValue !== undefined) {
						if (!valuesAreEqual(conditionValue, actualValue)) {
							continue // Skip this validation rule
						}
					}
					// If condition value is null/undefined, show required fields (default behavior)
				}

				// Check if current attribute is in required list
				for (let j = 0; j < rule.required.length; j++) {
					if (that.lang && rule.required[j].attribute === that.attributeName && rule.required[j].language === that.lang) {
						required = true
					}
					if (that.lang && rule.required[j].attribute === that.attributeName && !rule.required[j].language) {
						required = true
					}
					if (!that.lang && rule.required[j].attribute === that.attributeName) {
						required = true
					}
				}
			}

			return required
		},
		requiredLabel: function () {
			return this.isRequired ? 'required-label': ''
		},
		requiredLabelIcon: function () {
			return this.isRequired ? 'required': ''
		},
		requiredPrimaryIcon: function () {
			return this.isPrimary ? 'primary': ''
		}
	}
}
